export const GET_CAREGIVERS = 'GET_CAREGIVERS';
export const GET_CAREGIVERS_DONE = 'GET_CAREGIVERS_DONE';
export const GET_CAREGIVERS_ERROR = 'GET_CAREGIVERS_ERROR';
export const RESET_CAREGIVERS = 'RESET_CAREGIVERS';
//# sourceMappingURL=actionTypes.js.map